import iconChevronLeftDark from "@assets/icon-chevron-left-dark.svg";
import iconChevronLeftLight from "@assets/icon-chevron-left-light.svg";
import { cn } from "@util/helpers";

export default function SplidePrevArrow(): React.ReactElement {
  return (
    <button
      className={cn(
        "splide__arrow splide__arrow--prev",
        "relative left-[unset] right-0 top-[unset] translate-x-0",
        "!h-9 !w-9 rounded-full !border !border-solid border-gray-175 bg-white text-gray-850 !opacity-100 hover:border-gray-850",
        "group cursor-pointer disabled:cursor-auto disabled:border-gray-175"
      )}
    >
      <img
        src={iconChevronLeftDark}
        width={24}
        height={24}
        alt="Next slide"
        className="block flex-shrink-0 group-disabled:hidden"
      />

      <img
        src={iconChevronLeftLight}
        width={24}
        height={24}
        alt="Next slide"
        className="hidden flex-shrink-0 group-disabled:block"
      />
    </button>
  );
}
